/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { getInfCLogger } from '@infodata-group/inf-commons-core';
import { DataModel } from '../../engine/data-model';
import { Observable } from 'rxjs';
import { TableManager } from './table-manager';
import { IEntity } from '../../interface/IEntity';

const logger = getInfCLogger('DataTableManager');

/**
 * Manager for DataTable
 */
export class DataTableManager<T extends IEntity> extends TableManager<T> {
  override get printableData(): any[] {
    return this.data;
  }
  constructor(model: DataModel, data: T[]) {
    super(model);
    this.data = data;
  }

  public getEntities(): Observable<T[]> {
    return this.loadSubject.asObservable();
  }

  load(): void {
    this.count = this.data.length;
    this.applyAllFilters();
  }

  changePage(page: number, step: number) {
    this.currentPage = page;
    void step;
  }

  changeStep(previousValue: number, newValue: number) {
    logger.debug(`Change step from "${previousValue}" -> "${newValue}"`);
    this.currentPage = 0;
  }

  initPage(page: number) {
    this.currentPage = page;
  }

  notifySort(data: T[]) {
    this.loadSubject.next(data);
  }

  override addRow(row: T) {
    this.data.push(row);
    this.notify();
  }
}
